import { useEffect } from 'react';

export const useKeySelect = (shouldListen, callback) => {
  useEffect(() => {
    if (shouldListen) {
      window.addEventListener('keydown', callback);
    }

    return () => {
      window.removeEventListener('keydown', callback);
    };
  }, [shouldListen, callback]);
};
